import { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import TogglePasswordField from "./TogglePasswordField";
import { Link, useNavigate } from "react-router-dom";

import "./../styles/registration_form_model.style.css";
import Loader from "./Loader";
import { API_REGISTER } from "../ApiEndPoints";
import AxiosClient from "../client/AxiosClient";
import DismissableAlert from "./DismissableAlert";
import { SERVER_ERR_MSG } from "../DefaultMsg";

import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import Recaptcha from "./../google_captcha/Recaptcha";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../redux/slice/UserSessionSlice";

export default function RegisterationFormModal() {
  const navigateTo = useNavigate();
  const [show, setShow] = useState(true);

  // const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);

  let cartCourse = useSelector((state) => state.cart);

  const [formValues, setFormValues] = useState({
    name: "",
    email: "",
    mobile: "",
    password: "",
    recaptchaToken: "",
    interested_course: "",
  });

  const [formErrors, setFormErrors] = useState({
    name: "",
    email: "",
    mobile: "",
    password: "",
    recaptchaToken: "",
    interested_course: "",
  });

  const [showLoader, setShowLoader] = useState(false);
  const [showAlert, setshowAlert] = useState({
    show: false,
    type: "",
    title: "",
    desc: "",
  });

  function setPasswordField(password) {
    setFormValues({ ...formValues, password: password });
  }

  const handleRecaptchaVerify = (token) => {
    setFormValues((prev) => ({ ...prev, recaptchaToken: token }));
  };

  const dispatch = useDispatch();

  const [executeRecaptcha, setExecuteRecaptcha] = useState(null);

  async function handleSubmit(event) {
    event.preventDefault();

    if (executeRecaptcha) {
      const newToken = await executeRecaptcha("register");
      setFormValues((prev) => ({ ...prev, recaptchaToken: newToken }));
    }

    if (!executeRecaptcha) {
      alert("Recaptcha not ready. Please try again.");
      return;
    }

    const newToken = await executeRecaptcha("register");
    setFormValues((prev) => ({ ...prev, recaptchaToken: newToken }));

    if (!newToken) {
      alert("Please complete reCAPTCHA verification.");
      return;
    }

    setShowLoader(true);
    setshowAlert({
      show: false,
    });

    AxiosClient.post(API_REGISTER, formValues)
      .then((response) => {
        const { data: responseData } = response;

        if (responseData.success === true) {
          setFormErrors({
            name: "",
            email: "",
            mobile: "",
            password: "",
            interested_course: "",
          });

          setshowAlert({
            show: true,
            type: "success",
            title: "",
            desc: responseData.message,
          });

          // starting session
          localStorage.setItem("token", responseData.data.access_token);
          localStorage.setItem("login_name", responseData.data.profile.name);
          localStorage.setItem("login_email", responseData.data.profile.email);
          localStorage.setItem("login_phone", responseData.data.profile.phone);
          localStorage.setItem("avatar", responseData.data.profile.avatar);

          dispatch(
            login({
              name: responseData.data.profile.name,
              email: responseData.data.profile.email,
              token: responseData.data.access_token,
              avatar: responseData.data.profile.avatar,
            })
          );

          let redirect_url = cartCourse.length > 0 ? "/cart" : "/dashboard";
          setTimeout(() => {
            navigateTo(redirect_url);
          }, 1000);
        } else {
          setFormErrors({
            name:
              responseData.errors.name != null ? responseData.errors.name : "",
            email:
              responseData.errors.email != null
                ? responseData.errors.email
                : "",
            mobile:
              responseData.errors.mobile != null
                ? responseData.errors.mobile
                : "",
            password:
              responseData.errors.password != null
                ? responseData.errors.password
                : "",
          });

          setshowAlert({
            show: true,
            type: "danger",
            title: "",
            desc: responseData.message,
          });

          console.log(showAlert);
        }
      })
      .catch((err) => {
        console.error(err);

        setshowAlert({
          show: true,
          type: "danger",
          title: "",
          desc: SERVER_ERR_MSG,
        });

        setShowLoader(false);
      })
      .finally(() => {
        setShowLoader(false);
      });
  }

  return (
    <>
      <Modal
        className="login-modal"
        show={show}
        onHide={() => {
          navigateTo("/");
        }}
        centered
      >
        <Modal.Header className="border-0 pt-4 text-center" closeButton>
          <Modal.Title className="w-100">Register</Modal.Title>
        </Modal.Header>
        <p className="text-center px-5">
          Learn on your own time from top universities and businesses.
        </p>

        <Modal.Body>
          <GoogleReCaptchaProvider
            reCaptchaKey={process.env.REACT_APP_SITE_KEY}
          >
            <Form onSubmit={handleSubmit} autoComplete="off">
              <Form.Group className="mb-3" controlId="your_name">
                <Form.Label>
                  Name <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Your name"
                  value={formValues.name}
                  onChange={(e) => {
                    setFormValues({ ...formValues, name: e.target.value });
                  }}
                />
                <span className="validation-err text-danger">
                  {formErrors.name}
                </span>
              </Form.Group>
              <Form.Group className="mb-3" controlId="your_email">
                <Form.Label>
                  Email <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="email"
                  placeholder="yourmail@example.com"
                  value={formValues.email}
                  onChange={(e) => {
                    setFormValues({ ...formValues, email: e.target.value });
                  }}
                />
                <span className="validation-err text-danger">
                  {formErrors.email}
                </span>
              </Form.Group>
              <Form.Group className="mb-3" controlId="your_phone">
                <Form.Label>
                  Mobile no. <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder=""
                  value={formValues.mobile}
                  onChange={(e) => {
                    setFormValues({ ...formValues, mobile: e.target.value });
                  }}
                />
                <span className="validation-err text-danger">
                  {formErrors.mobile}
                </span>
              </Form.Group>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>
                  Password <span className="text-danger">*</span>
                </Form.Label>
                <TogglePasswordField
                  password={formValues.password}
                  setPassword={setPasswordField}
                />
                <span className="validation-err text-danger">
                  {formErrors.password}
                </span>
              </Form.Group>

              <Form.Group className="mb-3" controlId="your_name">
                <Form.Label>Interested course (Optional)</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Course name"
                  value={formValues.interested_course}
                  onChange={(e) => {
                    setFormValues({
                      ...formValues,
                      interested_course: e.target.value,
                    });
                  }}
                />
                <span className="validation-err text-danger">
                  {formErrors.interested_course}
                </span>
              </Form.Group>

              {showAlert.show === true && (
                <DismissableAlert
                  varient={showAlert.type}
                  title={showAlert.title}
                  desc={showAlert.desc}
                />
              )}

              {/* Recaptcha Component */}
              <Recaptcha
                onVerify={handleRecaptchaVerify}
                setExecuteRecaptcha={setExecuteRecaptcha}
                actionName="login"
              />
              <Button
                type="submit"
                className="btn btn-primary theme-btn bg-primary d-block w-100 mt-5"
                disabled={showLoader ? true : false}
              >
                <span className="me-2">Register</span>
                {showLoader && <Loader classes="text-white" />}
              </Button>

              <p className="d-flex justify-content-center flex-wrap mt-4 text-sm">
                <span className="text-muted">Already have an account?</span>
                <Button
                  type="button"
                  variant="transparent"
                  className="p-0 m-0 ms-1 text-decoration-underline link"
                  onClick={() => navigateTo("/?action=login")}
                >
                  Login
                </Button>
              </p>

              <hr className="my-4" />
              <p className="d-flex justify-content-center flex-wrap mt-3 text-sm">
                <span className="text-muted">
                  Having trouble in registration?
                </span>
                <Button
                  type="button"
                  variant="transparent"
                  className="p-0 m-0 ms-1 text-decoration-underline link"
                >
                  Visit help center
                </Button>
              </p>
            </Form>
          </GoogleReCaptchaProvider>
        </Modal.Body>
      </Modal>
    </>
  );
}
